import { create } from "zustand";

const RESET = {
  isOpen: false,
  message: "",
  title: "",
  onConfirm: null,
  onCancel: null,
  buttonName: null,
  cancelButtonName: null,
  showCancel: false
};

const usePopupStore = create((set) => ({
  ...RESET,

  // showCancel is an explicit opt-in, not inferred from onConfirm — some existing call sites pass
  // onConfirm as a decorative no-op on a plain success alert (see addPartner.jsx), so presence of
  // onConfirm alone isn't a reliable signal that a dialog is a real two-way choice. Every existing
  // call site omits showCancel and keeps today's single-button rendering; pass showCancel: true
  // only for a genuine confirm-or-back-out flow (e.g. a destructive action).
  openPopup: ({ title, message, onConfirm, onCancel, buttonName, cancelButtonName, showCancel }) =>
    set({
      isOpen: true,
      message,
      title,
      onConfirm: onConfirm ?? null,
      onCancel: onCancel ?? null,
      buttonName: buttonName ?? null,
      cancelButtonName: cancelButtonName ?? null,
      showCancel: !!showCancel
    }),

  closePopup: () => set({ ...RESET }),

  confirmPopup: () =>
    set((state) => {
      if (state.onConfirm) {
        state.onConfirm();
      }
      return { ...RESET };
    }),

  cancelPopup: () =>
    set((state) => {
      if (state.onCancel) {
        state.onCancel();
      }
      return { ...RESET };
    })
}));

export default usePopupStore;
